// DevTools component contains Terminal and Prisma Studio.
import {
  ReactNode,
  useState,
} from 'react'
import classNames from 'classnames'

import Block, { Props as BlockProps } from './Block'

export interface DevTool {
  element: ReactNode
  title: string
  titleButtons?: BlockProps['titleButtons']
}

export interface Props {
  tools: DevTool[]
}

function DevTools({ tools }: Props) {
  return (
    <>
      <div
        className={classNames(
          'absolute',
          'top-[calc(50%-40px)]',
          'left-[calc(50%-40px)]',
          'h-[80px]',
          'w-[80px]',
          'opacity-1',
          'transition-all',
          'duration-1000'
        )}
      >
      </div>
      {tools.map(t => (
        <Block
          key={t.title}
          title={t.title}
          titleButtons={t.titleButtons}
        >
          {t.element}
        </Block>
      ))}
    </>
  )
}

export default DevTools
